import { useQuery } from 'react-query';
import { getSpecialLessonAwards } from '@yandex-int/k-common/client/api';
import { showNetworkError } from 'platform-components';

import { getUniqueQueryKeys } from 'utils/getUniqueQueryKey';

const queryKeys = getUniqueQueryKeys(['specialLessonAwards']);

const onError = (error: unknown) => {
    console.error(error);
    showNetworkError(error);
};

export const useSpecialLessonAwards = (metaSlug?: string, { enabled }: { enabled?: boolean } = {}) => {
    const isValidSlug = !!metaSlug?.trim();
    return useQuery([queryKeys.specialLessonAwards, metaSlug], () => getSpecialLessonAwards(metaSlug as string), {
        onError,
        enabled: (enabled ?? true) && isValidSlug,
    });
};
